import { render, staticRenderFns } from "./UnitCreateUpdate.vue?vue&type=template&id=54e2a930&scoped=true&"
import script from "./UnitCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./UnitCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UnitCreateUpdate.vue?vue&type=style&index=0&id=54e2a930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2a930",
  null
  
)

export default component.exports